import React, { useState } from "react";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from "@mui/material";

const ClosureDialog = ({ open, onClose, onSave }) => {

    const [closureNotes, setClosureNotes] = useState("");

    const handleSave = () => {
        if (!closureNotes.trim()) {
            alert("Closure Notes required");
            return;
        }

        onSave(closureNotes);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Close Ticket</DialogTitle>

            <DialogContent>
                <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={closureNotes}
                    onChange={(e) => setClosureNotes(e.target.value)}
                />
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave}>Save</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ClosureDialog;